<template>
    <tr>
        <th scope="row">
            <div class="media align-items-center">
                <div class="media-body">
                    <span class="name mb-0 text-sm">#{{ticket.identifier}}</span>
                </div>
            </div>
        </th>
        <td class="budget">
            {{ticket.title}}
        </td>
        <td>
            <i :class="[status.icon, status.class]"></i>
            <span class="status">{{status.name}}</span>
        </td>
        <td>
            <div>
                {{$moment(ticket.due_date).format('DD/MM/YYYY')}}
            </div>
        </td>
        <td class="text-center">
            <a class="btn btn-primary" :href="`/app/tickets/show/${ticket.identifier}`" role="button">
                <i :class="status.action"></i>
            </a>
        </td>
    </tr>
</template>

<script>
import Badge from '../../argon/components/Badge'
import ticket from './mixins/ticket';
export default {
    name: 'TicketItem',
    components: {
        Badge
    },
    props: {
        ticket: {
            type: Object,
            required: true
        }
    },
    mixins: [
        ticket,
    ]
}
</script>

<style>

</style>
